import { type PermissionEnum } from '../enums'
import { type UserTierEnum } from '../enums/UserTierEnum'

export interface PermissionConstructor {
  id: number
  key: PermissionEnum
  tier?: UserTierEnum
  canAssignToPrimaryCategories?: boolean
  canAssignToSecondaryCategories?: boolean
}

export class Permission {
  id: number
  key: PermissionEnum
  tier?: UserTierEnum
  canAssignToPrimaryCategories?: boolean
  canAssignToSecondaryCategories?: boolean

  constructor(data: PermissionConstructor) {
    this.id = data.id
    this.key = data.key
    this.tier = data.tier
    this.canAssignToPrimaryCategories = data.canAssignToPrimaryCategories
    this.canAssignToSecondaryCategories = data.canAssignToSecondaryCategories
  }
}
